import { QuoteColumnField } from '@pages/Quotes/QuotesTable/QuoteColumnField.enum';

export const SortQuoteQueryParam: Record<string, (order: string, prefixValue?: string) => string> = {
  [QuoteColumnField.QuoteId]: (order, prefixValue) => `${prefixValue}${order}id`,
  [QuoteColumnField.AccountName]: (order, prefixValue) => `${prefixValue}${order}customer.name`,
  [QuoteColumnField.ModifiedDate]: (order, prefixValue) => `${prefixValue}${order}updatedAt`,
  [QuoteColumnField.StatusChangeDate]: (order, prefixValue) =>
    `${prefixValue}${order}quoteLatestStatusChange.latestStatusChangeDate`,
  [QuoteColumnField.EffectiveDate]: (order, prefixValue) => `${prefixValue}${order}effectiveOn`,
  [QuoteColumnField.Underwriter]: (order, prefixValue) => `${prefixValue}${order}underwriter.user.lastName`,
  [QuoteColumnField.CreatedByUser]: (order, prefixValue) => `${prefixValue}${order}createdByUser.lastName`,
  [QuoteColumnField.CreatedAt]: (order, prefixValue) => `${prefixValue}${order}createdAt`,
  [QuoteColumnField.BusinessClass]: (order, prefixValue) => `${prefixValue}${order}productOption.name`,
  [QuoteColumnField.ProductLabel]: (order, prefixValue) => `${prefixValue}${order}productLabel.name`,
  [QuoteColumnField.ProductOffering]: (order, prefixValue) => `${prefixValue}${order}offering.insuranceProduct.name`,
  [QuoteColumnField.QuoteNumber]: (order, prefixValue) => `${prefixValue}${order}policyNumber.policyNumber`,
  [QuoteColumnField.Status]: (order, prefixValue) => `${prefixValue}${order}status.label`,
  [QuoteColumnField.Producer]: (order, prefixValue) => `${prefixValue}${order}brokerageProducer.user.lastName`,
  [QuoteColumnField.Brokerage]: (order, prefixValue) => `${prefixValue}${order}brokerage.name`,
  [QuoteColumnField.QuoteType]: (order, prefixValue) => `${prefixValue}${order}quoteType`,
  [QuoteColumnField.QuoteSource]: (order, prefixValue) => `${prefixValue}${order}reportingQuoteSource`,
  [QuoteColumnField.UnderwritingStatus]: (order, prefixValue) =>
    `${prefixValue}${order}quoteCurrentUnderwritingStatus.label`,
  [QuoteColumnField.TotalPremium]: (order, prefixValue) => `${prefixValue}${order}totalPremium`,
  [QuoteColumnField.FlaggedAsImportant]: (order) => `${order}uwFlaggedAsImportant`,
  // LIO-29798: sorting intentionally continues to key off the underlying writingCompanyId,
  // not the displayed issuing-company override — see the WritingCompany column comment
  // in getColumns.tsx.
  [QuoteColumnField.WritingCompany]: (order, prefixValue) => `${prefixValue}${order}writingCompany.name`,
};
